export default __webpack_public_path__ + "static/media/care-admin-default-avatar.a335e418.svg";